export { default as AttributeImage } from './themes/BGH';
export { masterAttribute } from './themes/BGH';
import Variant from './themes/BGH';
export default Variant;
